import { TRowModel } from '../types';

export const useRowDrag = <Row extends TRowModel<Row>>(onRowDrag?: () => void) => {
  // TODO: Row Drag functionalities
  return {
    onRowDrag,
  };
};
